import React from "react";

export default function Metalhand({ ...props }) {
  return (
    <span role="img" aria-label="metalhand">
      🤘
    </span>
  );
}
